module.exports = __webpack_public_path__ + "img/logo-small.ec89e59c.jpg";